import { css } from 'styled-components';
import { IApplyOnlineLayout } from './models';

// TODO - after redesign the theme SBT-5287
interface StyledProps extends IApplyOnlineLayout {
  theme: any;
}

export const ApplyOnlineLayout = ({ theme, page }: StyledProps) => {
  return css`
    width: 100%;
    overflow: hidden;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    > .top {
      ${!page.showStepper &&
      css`
        @media only screen and ${theme.device.laptopS} {
          margin-bottom: 20px;
        }
      `}
    }

    > .content {
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      width: fit-content;

      @media only screen and ${theme.device.laptopS} {
        min-width: 720px;
        min-height: 505px;
      }

      box-shadow: rgb(24 39 75 / 12%) 0 6px 14px -6px, rgb(24 39 75 / 10%) 0px 10px 32px -4px;
      padding: 20px 100px 20px 100px;
      border-radius: 25px;
      overflow-y: auto;
      overflow-x: hidden;

      margin: 0 auto 20px;

      @media only screen and ${theme.device.max.laptopS} {
        width: 100%;
        padding: 10px 20px;
        box-shadow: none;
        margin: 0;
        flex: 1 1 0;
      }
    }
  `;
};
